export default "__VITE_ASSET__Bn5PGBOt__"